export const suggestedActivities = [
  {
    id: 1,
    title: "Course: Image-Guided & Adaptive Radiotherapy (IGART 2026)",
    description: "A two-day hands-on course covering clinical implementation of image-guided radiotherapy, including SABR topics.",
    category: "Educational Activities",
    keywords: ["igart", "image-guided rt", "adaptive rt", "sabr"],
    type: "External Course",
    hours: 16.0,
    link: "https://www.icr.ac.uk/study-and-careers/opportunities-for-clinicians/radiotherapy-and-imaging-training-courses/image-guided-and-adaptive-radiotherapy-in-clinical-practice--including-sabr-topics",
    source: "Royal College of Radiologists (UK)"
  },
  {
    id: 2,
    title: "Course: Effective Cultural Communication in Oncology (eviQ)",
    description: "An online program to improve communication with patients from culturally and linguistically diverse backgrounds.",
    category: "Professional Development & Skills",
    keywords: ["communication", "cultural competence", "oncology"],
    type: "External Course",
    hours: 1.0,
    link: "https://education.eviq.org.au/courses/supportive-care/effective-cultural-communication-in-oncology",
    source: "eviQ Education"
  },
  {
    id: 3,
    title: "Workshop: Advanced Communication Skills (Virtual, MSKCC)",
    description: "A two-day interactive workshop for oncology clinicians, focusing on delivering difficult news empathetically.",
    category: "Professional Development & Skills",
    keywords: ["communication", "empathy", "oncology", "workshop"],
    type: "External Course",
    hours: 14.5,
    link: "https://msk.org/ComskilCourse",
    source: "Memorial Sloan Kettering"
  },
  {
    id: 4,
    title: "Course: Advanced Radiotherapy (eIntegrity UK)",
    description: "An interactive e-learning module on advanced radiotherapy techniques, with practice tools for SABR.",
    category: "Educational Activities",
    keywords: ["advanced radiotherapy", "sabr", "elearning"],
    type: "External Course",
    hours: 10.0,
    link: "https://www.eintegrity.org/healthcare-course/advanced-radiotherapy/",
    source: "eIntegrity"
  },
  {
    id: 5,
    title: "Webinar: Effective Cancer Communication (ECC)",
    description: "A workshop and webinars on communicating effectively with cancer patients, including telehealth scenarios.",
    category: "Professional Development & Skills",
    keywords: ["communication", "telehealth", "oncology", "webinar"],
    type: "External Course",
    hours: 4.0,
    link: "https://www.cancervic.org.au/get-support/for-health-professionals/training-education/effective-cancer-communication",
    source: "Cancer Council Victoria"
  },
  {
    id: 6,
    title: "Course: Radiation Oncology eLearning Intro (eviQ)",
    description: "Introduction to principles of radiation oncology via interactive case-based modules for new professionals.",
    category: "Educational Activities",
    keywords: ["radiation oncology", "intro", "elearning"],
    type: "External Course",
    hours: 10.0,
    link: "https://education.eviq.org.au/courses/radiation-oncology/radiation-oncology",
    source: "eviQ Education"
  },
  {
    id: 7,
    title: "Web Module: Rapid Learning – Radiation Therapy (MedCPD)",
    description: "A short module on the role, indications, and side-effects of radiation therapy.",
    category: "Educational Activities",
    keywords: ["radiation therapy", "elearning", "sabr"],
    type: "External Course",
    hours: 2.0,
    link: "https://medcpd.com/courses/rapid-learning-ask-me-anything-radiation-therapy/",
    source: "MedCPD"
  },
  {
    id: 8,
    title: "External Resource: Communication Strategies in Patient Care",
    description: "An online education program focused on improving communication skills with patients and their families.",
    category: "Professional Development & Skills",
    keywords: ["communication", "patient care", "oncology"],
    type: "External Course",
    hours: 2.0,
    link: "https://vcccalliancelearn.org.au/courses/communication-strategies-patient-care",
    source: "VCCC Alliance"
  },
  {
    id: 9,
    title: "SaberCase: Mock SABR Plan Competency Quiz",
    description: "Test your SABR planning knowledge with a case-based competency quiz on this site.",
    category: "Reviewing & Reflecting on Practice",
    keywords: ["quiz", "sabr planning", "competency"],
    type: "Internal Quiz",
    hours: 0.5,
    link: "/education",
    source: "SABRCalculator.com"
  },
  {
    id: 10,
    title: "Read and Reflect: Future of Liver SABR",
    description: "A clinical article discussing non-invasive SABR techniques for liver cancer, ideal for reflective logging.",
    category: "Reading & Research",
    keywords: ["liver sabr", "article", "non-invasive"],
    type: "External Article",
    hours: 0.5,
    link: "https://pinpointradiotherapy.com.au/articles/the-future-of-non-invasive-sabr-treatment-for-liver-cancer/",
    source: "Pinpoint Radiotherapy"
  },
  {
    id: 11,
    title: "SABR Symposium 2025 – Melbourne",
    description: "A multidisciplinary two-day SABR symposium including lectures, expert panels, and interactive workshops.",
    category: "Educational Activities",
    keywords: ["sabr", "symposium", "multidisciplinary", "conference"],
    type: "External Conference",
    hours: 16.0,
    link: "https://www.sabrsymposium.com/",
    source: "SABR Symposium"
  },
  {
    id: 12,
    title: "Course: SBRT/SABR Program (UT Southwestern)",
    description: "A comprehensive 2.5-day course on implementation of SBRT/SABR, covering planning, physics, and outcomes.",
    category: "Educational Activities",
    keywords: ["sbrt", "sabr", "course", "dosimetry", "planning"],
    type: "External Course",
    hours: 17.0,
    link: "https://www.utsouthwestern.edu/departments/radiation-oncology/education-training/continued-education/sbrt-program/",
    source: "UT Southwestern"
  },
  {
    id: 13,
    title: "UK SABR Consortium Workshops (RCR Learning Hub)",
    description: "Recorded multidisciplinary workshops on SABR topics like motion management and MDT sessions—now available online.",
    category: "Educational Activities",
    keywords: ["sabr", "workshop", "motion management", "mdt"],
    type: "External Course",
    hours: 8.0,
    link: "https://www.sabr.org.uk/workshops/",
    source: "RCR/SABR Consortium"
  },
  {
    id: 14,
    title: "Podcast: Rad Chat – Radiation Oncology",
    description: "An award-winning CPD-accredited podcast with expert conversations on radiotherapy advances, policy, and clinical reflection.",
    category: "Self-Directed Learning",
    keywords: ["podcast", "radiotherapy", "oncology", "cpd"],
    type: "External Podcast",
    hours: 0.5,
    link: "https://radchat.co.uk/",
    source: "Rad Chat"
  },
  {
    id: 15,
    title: "Podcast: At The Beam",
    description: "A high-yield, oncology-focused medical education podcast featuring short episodes on practical RT topics.",
    category: "Self-Directed Learning",
    keywords: ["podcast", "oncology", "radiation oncology"],
    type: "External Podcast",
    hours: 0.5,
    link: "https://www.atthebeam.com/",
    source: "At The Beam"
  },
  {
    id: 16,
    title: "E-Learning: Radiation Oncology Nursing Pathway (eviQ)",
    description: "Structured learning pathway for radiation oncology nurses, covering fundamentals to advanced modules.",
    category: "Educational Activities",
    keywords: ["nursing", "radiation oncology", "elearning", "pathway"],
    type: "External Course",
    hours: 17.5,
    link: "https://education.eviq.org.au/pages/learning-pathways/radiation-oncology-nursing",
    source: "eviQ Education"
  },
  {
    id: 17,
    title: "CPD Resource: RANZCR CPD Home & Handbook",
    description: "The official CPD portal and handbook for RANZCR fellows—templates, guidance, reporting tools, and PDP support.",
    category: "Professional Development & Skills",
    keywords: ["ranzcr", "cpd handbook", "pdp", "portfolio"],
    type: "External Resource",
    hours: 0.0,
    link: "https://www.ranzcr.com/fellows/general/cpd-overview",
    source: "RANZCR"
  },
  {
    id: 18,
    title: "Book: Handbook of Evidence-Based Radiation Oncology",
    description: "Comprehensive, evidence-driven clinical guidance across body sites, treatment planning, and outcomes.",
    category: "Reading & Research",
    keywords: ["handbook", "evidence-based", "radiation oncology", "book"],
    type: "Book",
    hours: 5.0,
    link: "https://www.amazon.com/Handbook-Evidence-Based-Radiation-Oncology/dp/1588294427",
    source: "Amazon"
  },
  {
    id: 19,
    title: "Book: Physics & Technology of Radiation Therapy",
    description: "Definitive textbook on radiation therapy physics with integrated clinical applications.",
    category: "Reading & Research",
    keywords: ["physics", "radiation therapy", "textbook", "book"],
    type: "Book",
    hours: 5.0,
    link: "https://www.amazon.com/Physics-Technology-Radiation-Therapy-Practice/dp/0521006377",
    source: "Amazon"
  },
  {
    id: 20,
    title: "Book: Fundamentals of Radiation Oncology (3rd Edition)",
    description: "Up-to-date resource covering fundamentals, techniques, and clinical applications including SABR.",
    category: "Reading & Research",
    keywords: ["fundamentals", "radiation oncology", "book"],
    type: "Book",
    hours: 5.0,
    link: "https://www.amazon.com/Fundamentals-Radiation-Oncology-Physical-Biological/dp/3132417980",
    source: "Amazon"
  },
  {
    id: 21,
    title: "Book: Pocket Radiation Oncology (2025 edition)",
    description: "Handy pocket guide summarizing key SABR principles and clinical protocols for quick reference.",
    category: "Reading & Research",
    keywords: ["pocket guide", "sabr", "protocols", "book"],
    type: "Book",
    hours: 1.0,
    link: "https://bookauthority.org/books/pocket-radiation-oncology",
    source: "BookAuthority"
  },
  {
    id: 22,
    title: "Video: SABR Reirradiation and Adaptive Radiotherapy",
    description: "Recent talk on the evolving area of SABR reirradiation and adaptive planning approaches.",
    category: "Self-Directed Learning",
    keywords: ["sabr", "reirradiation", "adaptive radiotherapy", "video"],
    type: "External Video",
    hours: 1.0,
    link: "https://www.youtube.com/watch?v=vGWUuPFiOHI", // Placeholder Link
    source: "YouTube"
  },
  {
    id: 23,
    title: "Video: SABR for Prostate Cancer – Sean Sachdev, MD",
    description: "An overview presented by Northwestern faculty on SABR techniques in prostate radiotherapy.",
    category: "Self-Directed Learning",
    keywords: ["prostate", "sabr", "techniques", "video"],
    type: "External Video",
    hours: 0.75,
    link: "https://www.youtube.com/watch?v=nin12jjmw5E", // Placeholder Link
    source: "YouTube"
  },
  {
    id: 24,
    title: "Video: How SBRT Is Planned — Step-by-Step",
    description: "Clear walk-through of SBRT planning process—useful for trainees and planners.",
    category: "Self-Directed Learning",
    keywords: ["sbrt", "planning", "tutorial", "video"],
    type: "External Video",
    hours: 0.5,
    link: "https://www.youtube.com/watch?v=nLkTogA1-iI", // Placeholder Link
    source: "YouTube"
  },
  {
    id: 25,
    title: "Video: Understanding Radiation Oncology – Stanford",
    description: "Stanford’s introduction to radiation therapy innovations and the evolving role of RT in cancer care.",
    category: "Self-Directed Learning",
    keywords: ["radiation oncology", "overview", "stanford", "video"],
    type: "External Video",
    hours: 0.5,
    link: "https://www.youtube.com/watch?v=R-tdwIYoAkE", // Placeholder Link
    source: "YouTube"
  },
  {
    id: 26,
    title: "Book Series: Oncology and Radiation Therapy Textbooks",
    description: "Comprehensive academic-textbook listings covering cutting-edge oncology and radiotherapy research.",
    category: "Reading & Research",
    keywords: ["textbooks", "radiation oncology", "reference", "book"],
    type: "Book Platform",
    hours: 2.0,
    link: "https://www.routledge.com/medicine/clinical-medicine/oncology-and-radiation-therapy",
    source: "Routledge"
  },
  {
    id: 27,
    title: "Resource: NCI Workshop on AI in Radiation Oncology (2019)",
    description: "A workshop report outlining educational approaches for training clinicians in AI in radiotherapy.",
    category: "Reading & Research",
    keywords: ["ai", "radiation oncology", "nci", "report"],
    type: "External Resource",
    hours: 1.0,
    link: "https://arxiv.org/abs/1910.13334",
    source: "NCI / arXiv"
  },
  {
    id: 28,
    title: "Online Lecture Series: Radiation Oncology (Harvard)",
    description: "Video-based lecture recordings from Harvard faculty covering principles of radiation oncology and cancer biology.",
    category: "Self-Directed Learning",
    keywords: ["oncology lectures", "video learning", "harvard"],
    type: "Video Series",
    hours: 1.5,
    link: "https://www.youtube.com/playlist?list=PLtIFIE0nMG6p8sMydcA9pX3xA8AemD4fV", // Placeholder Link
    source: "Harvard Medical School"
  },
  {
    id: 29,
    title: "Webinar Series: Advances in SABR (ESTRO)",
    description: "Live and recorded webinars focusing on stereotactic radiotherapy techniques, clinical trials, and case applications.",
    category: "Educational Activities",
    keywords: ["estro", "webinar", "sabr"],
    type: "Live/Recorded Webinar",
    hours: 2.0,
    link: "https://www.estro.org/Congresses/Online-education/Webinars",
    source: "ESTRO"
  },
  {
    id: 30,
    title: "Textbook: Perez & Brady’s Principles of Radiation Oncology",
    description: "One of the most widely used radiation oncology textbooks, updated with the latest treatment protocols.",
    category: "Reading & Research",
    keywords: ["oncology textbook", "clinical reference", "perez & brady", "book"],
    type: "Book",
    hours: 3.0,
    link: "https://www.wolterskluwer.com/en/solutions/ovid/perez-and-bradys-principles-and-practice-of-radiation-oncology-17537",
    source: "Wolters Kluwer"
  },
  {
    id: 31,
    title: "Podcast: Radiation Oncology Podcasts (ASTRO & RCR)",
    description: "Regular podcasts covering updates, case discussions, and career development for oncology professionals.",
    category: "Self-Directed Learning",
    keywords: ["podcast", "astro", "rcr"],
    type: "Podcast",
    hours: 1.0,
    link: "https://www.astro.org/News-and-Publications/Podcasts",
    source: "ASTRO"
  },
  {
    id: 32,
    title: "Simulation-Based Training: Virtual Radiotherapy (VERT)",
    description: "Immersive training simulator used globally for radiation therapy planning and treatment verification.",
    category: "Technology & Innovation",
    keywords: ["simulation", "practical skills", "training", "vert"],
    type: "Virtual Platform",
    hours: 2.5,
    link: "https://www.vertual.co.uk/",
    source: "Vertual Ltd."
  },
  {
    id: 33,
    title: "Clinical Guideline Study: SABR Guidelines (NCCN, NICE)",
    description: "Review and application of official SABR and radiotherapy clinical practice guidelines from international authorities.",
    category: "Reviewing & Reflecting on Practice",
    keywords: ["nccn", "nice", "estro", "guidelines"],
    type: "Guideline Resource",
    hours: 1.5,
    link: "https://www.nccn.org/professionals/physician_gls/pdf/nscl.pdf",
    source: "NCCN"
  },
  {
    id: 34,
    title: "MOOC: Radiobiology & Radiation Physics (Coursera/EdX)",
    description: "Free and paid online courses covering the biological and physical principles behind radiation therapy.",
    category: "Educational Activities",
    keywords: ["mooc", "radiobiology", "physics", "course"],
    type: "Course",
    hours: 6.0,
    link: "https://www.coursera.org/learn/fundamentals-radiation-biology",
    source: "Coursera"
  },
  {
    id: 35,
    title: "Case-Based CPD: SABR Scenarios (RCR)",
    description: "Structured case-based learning activities designed to test knowledge in SABR treatment decision-making.",
    category: "Reviewing & Reflecting on Practice",
    keywords: ["case study", "sabr", "rcr"],
    type: "Case-Based Learning",
    hours: 2.0,
    link: "https://www.rcr.ac.uk/",
    source: "Royal College of Radiologists"
  },
  {
    id: 36,
    title: "ASTRO Annual Meeting",
    description: "Premier international radiation oncology conference featuring keynote lectures, scientific sessions, and networking opportunities.",
    category: "Educational Activities",
    keywords: ["astro", "conference", "oncology"],
    type: "Conference",
    hours: 20.0,
    link: "https://www.astro.org/Meetings-and-Education",
    source: "ASTRO"
  },
  {
    id: 37,
    title: "Course: Improving Your Radiation Oncology Practice (Harvard)",
    description: "Professional development course for clinicians to improve decision-making and patient-centered outcomes.",
    category: "Educational Activities",
    keywords: ["harvard", "oncology", "professional development"],
    type: "Online Course",
    hours: 4.0,
    link: "https://online-learning.harvard.edu/",
    source: "Harvard Online"
  },
  {
    id: 38,
    title: "Meditation and Resilience Training for Clinicians",
    description: "Wellness and mindfulness training for healthcare professionals to reduce burnout and improve resilience.",
    category: "Wellbeing & Resilience",
    keywords: ["resilience", "mindfulness", "wellness"],
    type: "Online Training",
    hours: 3.0,
    link: "https://www.mindful.org/mindfulness-training-healthcare/",
    source: "Mindful.org"
  },
  {
    id: 39,
    title: "Radiopaedia Case Contributor Program",
    description: "Contribute cases to the Radiopaedia database, building both knowledge and teaching experience.",
    category: "Teaching, Training & Supervising",
    keywords: ["radiopaedia", "case studies", "collaboration"],
    type: "Online Contribution",
    hours: 2.0,
    link: "https://radiopaedia.org/contribute",
    source: "Radiopaedia"
  },
  {
    id: 40,
    title: "ESTRO Workshops",
    description: "Hands-on workshops covering advanced imaging, treatment planning, and new radiation modalities.",
    category: "Educational Activities",
    keywords: ["estro", "workshops", "radiation therapy"],
    type: "In-person Workshop",
    hours: 6.0,
    link: "https://www.estro.org/Courses",
    source: "ESTRO"
  },
  {
    id: 41,
    title: "LinkedIn Learning: Leadership Skills for Clinicians",
    description: "Short, structured CPD course aimed at improving leadership and communication skills in healthcare settings.",
    category: "Professional Development & Skills",
    keywords: ["leadership", "communication", "linkedin learning"],
    type: "Online Course",
    hours: 1.5,
    link: "https://www.linkedin.com/learning/",
    source: "LinkedIn Learning"
  },
  {
    id: 42,
    title: "Oncology Education Podcast",
    description: "Podcast series covering new research in oncology and radiation therapy, offering CPD-eligible reflective learning.",
    category: "Self-Directed Learning",
    keywords: ["oncology", "podcast", "reflective learning"],
    type: "Podcast",
    hours: 0.5,
    link: "https://www.oncologyeducation.com/podcast",
    source: "Oncology Education"
  },
  {
    id: 43,
    title: "BMJ OnExamination Self-Assessment Tools",
    description: "Bank of self-assessment questions and practice exams designed for healthcare professionals preparing for specialty exams.",
    category: "Reviewing & Reflecting on Practice",
    keywords: ["bmj", "self-assessment", "exam prep"],
    type: "Online Assessment",
    hours: 2.0,
    link: "https://onexamination.bmj.com/",
    source: "BMJ"
  },
  {
    id: 44,
    title: "Coursera: Machine Learning for Healthcare",
    description: "An applied course exploring how AI and machine learning can be used to enhance healthcare diagnostics and decision-making.",
    category: "Technology & Innovation",
    keywords: ["ai", "machine learning", "healthcare", "course"],
    type: "Online Course",
    hours: 6.0,
    link: "https://www.coursera.org/",
    source: "Coursera"
  },
  {
    id: 45,
    title: "Royal College of Radiologists eLearning Hub",
    description: "A library of structured online modules designed to support professional development and CPD requirements.",
    category: "Educational Activities",
    keywords: ["rcr", "elearning", "radiology"],
    type: "Online Module",
    hours: 2.0,
    link: "https://hub.rcr.ac.uk/",
    source: "Royal College of Radiologists"
  }
];